import { create } from 'zustand';

import { PDFResult } from '../models/pdfModal';

interface RiskTransferStore {
  canAbsorbRisk: boolean | null;
  setCanAbsorbRisk: (_: boolean) => void;

  riskManagementSummaryReportPDF: PDFResult | null;
  setRiskManagementSummaryReportPDF: (_: PDFResult | null) => void;
}

const useRiskTransferStore = create<RiskTransferStore>((set) => ({
  canAbsorbRisk: null,
  setCanAbsorbRisk: (data: boolean) => set({ canAbsorbRisk: data }),

  riskManagementSummaryReportPDF: null,
  setRiskManagementSummaryReportPDF: (data: PDFResult | null) =>
    set({ riskManagementSummaryReportPDF: data }),
}));

export default useRiskTransferStore;
